import { useState } from "react";
import "../styles/NavBar.css";
import "animate.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { HiOutlineX } from "react-icons/hi";

export default function NavBar() {
    const [menuOpen, setMenuOpen] = useState(false);

    function toggleMenu() {
        setMenuOpen((prev) => !prev);
    }

    return (
        <section>
            <nav className="navbar">
                <div className="name">Akhil</div>

                <div className="menu-items">
                    <a href={"#about-section"} className="nav-links">About Me</a>
                    <a href={"#experience"} className="nav-links">Experience</a>
                    <a href={"#projects"} className="nav-links">Projects</a>
                    <a href={"#resume"} className="nav-links">Resume</a>
                </div>

                {/* Hamburger / Close Icon */}
                <div className="hamburger-menu" onClick={toggleMenu}>
                    {menuOpen ? <HiOutlineX /> : <GiHamburgerMenu />}
                </div>
            </nav>

            {/* Mobile Menu */}
            <section
                className={`mobile-menu-items ${menuOpen ? "active" : ""}`}
            >
                <a href={"#about-section"} className="m-nav-links" onClick={toggleMenu}>About Me</a>
                <a href={"#experience"} className="m-nav-links" onClick={toggleMenu}>Experience</a>
                <a href={"#projects"} className="m-nav-links" onClick={toggleMenu}>Projects</a>
                <a href={"#resume"} className="m-nav-links" onClick={toggleMenu}>Resume</a>
            </section>
        </section>
    );
}
